import { Box, Flex, Grid, Heading, Text, useToken } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { CatalogCardSkeleton, ProgramCatalogCard } from '~/features/catalog/components/catalog-card-program';
import { useCatalogItems } from '~/features/catalog/hooks/use-catalog-items';

export type AIProgramsSectionProps = {
  title: string;
  description: string;
  programKeys: string[];
};

export function AIProgramsSection({ title, description, programKeys }: AIProgramsSectionProps) {
  const [contentMaxWidth] = useToken('sizes', ['content-max-width']);
  const { catalogItems, catalogItemsIsLoading } = useCatalogItems(programKeys);

  if (!catalogItemsIsLoading && !catalogItems?.length) return null;

  return (
    <Box
      as='section'
      bgGradient='linear(90deg, rgba(98, 187, 255, 0.12) 0%, rgba(0, 106, 255, 0.12) 100%)'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer>
        <Box
          textAlign='center'
          mb={{
            base: 10,
            md: 12,
          }}
        >
          <Heading
            as='h2'
            size={{
              base: 'marketing-2xl',
              md: 'marketing-5xl',
            }}
          >
            {title}
          </Heading>
          <Text>{description}</Text>
        </Box>
      </ContentContainer>
      <Flex
        overflow='auto'
        paddingEnd={{ md: '16px' }}
        paddingStart={`calc((100% - ${contentMaxWidth}) / 2)`}
        sx={{
          scrollBarWidth: 'thin',
          '&::before,&::after': {
            content: "''",
            display: 'block',
            width: {
              base: '16px',
              md: '24px',
              lg: '48px',
              xl: 'unset',
            },
            flexShrink: 0,
          },
        }}
      >
        <Grid gap={4} gridAutoColumns='210px' gridAutoFlow='column' gridAutoRows='full' paddingBottom='16px'>
          {catalogItemsIsLoading && (
            <>
              <CatalogCardSkeleton />
              <CatalogCardSkeleton />
              <CatalogCardSkeleton />
              <CatalogCardSkeleton />
              <CatalogCardSkeleton />
            </>
          )}
          {!catalogItemsIsLoading &&
            catalogItems?.map((catalogItem) => <ProgramCatalogCard key={catalogItem.key} catalogItem={catalogItem} />)}
        </Grid>
      </Flex>
    </Box>
  );
}
